import React from "react";
import { Link } from "react-router-dom";
import Tags from "./Tags";

export default function RelatedPost({ post }) {
  const { title, tags, date, image } = post || {};
  return (
    <div className="card">
      <Link to={`/post/${post.id}`}>
        <img src={image} className="card-image" alt="" />
      </Link>
      <div className="p-4">
        <Link to={`/post/${post.id}`} className="text-lg post-title lws-RelatedPostTitle">
          {title}
        </Link>
        <Tags tags={tags} />
        <p>{date}</p>
      </div>
    </div>
  );
}
